module.exports = __webpack_public_path__ + "img/descargar.847ab5fa.png";